import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox, FDList,
  FDListItem, FDListItemText,
  FDStack,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';

const PlannerTransitionSegmentKey = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <FDBox padding={200}>
      <FDStack direction={'column'} alignItems="flex-start" justifyContent="flex-start">
        <MetaField attr={'title'} />
        <FDBox padding={200}>
          <FDList>
            {resource.attr('segmentDescriptions').map((description) => (
              <FDListItem
                key={description.replaceAll(' ', '-')}
              >
                <FDListItemText primaryText={description} />
              </FDListItem>
            ))}
          </FDList>
        </FDBox>
      </FDStack>
    </FDBox>
  );
};

export default PlannerTransitionSegmentKey;
